import React, { useContext, useEffect, useState } from "react";
import Column from "@amzn/meridian/column";
import Routing from "../routing";
import { IntlProvider } from "react-intl";
import LocaleManagerInstance from "../locale/locale-manager";
import {
  Constants,
  DataHandler,
  FeatureManager,
  MeshClient,
} from "@amzn/dolphin-web-framework";
import AppTopNavigation from "./app-top-navigation";
import AppContextProvider from "../context/app-context";
import { Loader } from "@amzn/dolphin-uiweb-framework";
import VSAContextProvider from "../context/vsa-context";
import { withDevSupport } from "src/dev-support";
import { DevContext } from "src/context/dev-context";

function App() {
  const { devState } = useContext(DevContext);

  const locale = LocaleManagerInstance.getLocale(
    !devState.isDevMode ? DataHandler.getUserLocale() : devState.devLocale
  );
  const messages = LocaleManagerInstance.getMessages(
    !devState.isDevMode ? DataHandler.getUserLocale() : devState.devLocale
  );

  const [direction, setDirection] = useState("ltr");
  const [initialise, setInitialise] = useState(false);

  useEffect(() => {
    DataHandler.setUserFeatures(
      FeatureManager.Features.CREATE_HELP_REQUEST_ENABLED
    );

    async function init() {
      await MeshClient.connectWebSocket();

      //To be modified with actual stage and region when backend is finalised
      await FeatureManager.getFeatures(
        Constants.Stage.GAMMA,
        Constants.Region.REGION_EU
      );

      setInitialise(false);
    }

    init();

    return async () => {
      MeshClient.closeWebSocketConnection();
    };
  }, []);

  useEffect(() => {
    const dir = LocaleManagerInstance.getDirection(
      !devState.isDevMode ? DataHandler.getUserLocale() : devState.devLocale
    );
    setDirection(dir);
  }, [devState.isDevMode, devState.devLocale]);

  //Displays content direction based on locale
  const DirectionContainer = ({ children }) => {
    return <div dir={direction}>{children}</div>;
  };

  return (
    <IntlProvider locale={locale} messages={messages} defaultLocale="en">
      <AppContextProvider>
        <VSAContextProvider>
          {initialise ? (
            <Loader />
          ) : (
            <Column id="container">
              {withDevSupport(
                <DirectionContainer>
                  <Column
                    id="actualUI"
                    height={!devState.isDevMode ? window.outerHeight : "680px"}
                    spacing="none"
                    spacingInset="none"
                    alignmentVertical="justify"
                  >
                    <React.Suspense fallback={null}>
                      <AppTopNavigation />
                    </React.Suspense>
                    <Column
                      classname="container"
                      height="100%"
                      spacing="none"
                      spacingInset="none"
                    >
                      <Routing />
                    </Column>
                  </Column>
                </DirectionContainer>
              )}
            </Column>
          )}
        </VSAContextProvider>
      </AppContextProvider>
    </IntlProvider>
  );
}

export default App;
